/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var atcAction = function (productID, multipleVariants, variantID, productURL) {
  let buttons = document.getElementsByClassName(productID + "-" + variantID);
  for (let button of buttons) {
    button.innerHTML = '<div class="spinner"></div>';
  }
  const formData = {
    items: [
      {
        id: variantID,
        quantity: 1,
      },
    ],
  };
  if (multipleVariants) {
    window.open(productURL, "_self");
  } else {
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then(function (response) {
        for (let button of buttons) {
          button.innerHTML =
            '<svg role="presentation" viewBox="0 0 20 20"><path d="M7 18a.997.997 0 01-.707-.293l-6-6a1 1 0 011.414-1.414l5.236 5.236 11.298-13.18a1 1 0 011.518 1.3l-12 14a1.001 1.001 0 01-.721.35H7" fill="currentColor"/></svg>';
        }
        // console.log(data.quantity);
        document.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variant: variantID,
              quantity: 1,
            },
          })
        );
      })
      .catch((error) => {
        let errorMsg = document.getElementById(
          "error-" + productID + "-" + variantID
        );
        for (let button of buttons) {
          button.innerHTML =
            '<svg class="Icon Icon--cart-desktop" role="presentation" viewBox="0 0 19 23"><path d="M0 22.985V5.995L2 6v.03l17-.014v16.968H0zm17-15H2v13h15v-13zm-5-2.882c0-2.04-.493-3.203-2.5-3.203-2 0-2.5 1.164-2.5 3.203v.912H5V4.647C5 1.19 7.274 0 9.5 0 11.517 0 14 1.354 14 4.647v1.368h-2v-.912z" fill="currentColor"></path></svg>';
        }
        errorMsg.classList.add("errorMsg");
        errorMsg.innerHTML =
          data.responseJSON.message + ": " + data.responseJSON.description;
      });
    // $.ajax({
    //   type: "POST",
    //   url: "/cart/add.js",
    //   data: {
    //     quantity: 1,
    //     id: variantID,
    //   },
    //   dataType: "json",
    //   success: function (data) {
    //     for (let button of buttons) {
    //       button.innerHTML =
    //         '<svg role="presentation" viewBox="0 0 20 20"><path d="M7 18a.997.997 0 01-.707-.293l-6-6a1 1 0 011.414-1.414l5.236 5.236 11.298-13.18a1 1 0 011.518 1.3l-12 14a1.001 1.001 0 01-.721.35H7" fill="currentColor"/></svg>';
    //     }
    //     console.log(data.quantity);

    //     document.dispatchEvent(
    //       new CustomEvent("product:added", {
    //         bubbles: true,
    //         detail: {
    //           variant: variantID,
    //           quantity: 1,
    //         },
    //       })
    //     );
    //   },
    //   error: function (data) {
    //     let errorMsg = document.getElementById(
    //       "error-" + productID + "-" + variantID
    //     );
    //     for (let button of buttons) {
    //       button.innerHTML =
    //         '<svg class="Icon Icon--cart-desktop" role="presentation" viewBox="0 0 19 23"><path d="M0 22.985V5.995L2 6v.03l17-.014v16.968H0zm17-15H2v13h15v-13zm-5-2.882c0-2.04-.493-3.203-2.5-3.203-2 0-2.5 1.164-2.5 3.203v.912H5V4.647C5 1.19 7.274 0 9.5 0 11.517 0 14 1.354 14 4.647v1.368h-2v-.912z" fill="currentColor"></path></svg>';
    //     }
    //     errorMsg.classList.add("errorMsg");
    //     errorMsg.innerHTML =
    //       data.responseJSON.message + ": " + data.responseJSON.description;
    //   },
    // });
  }
};

document.addEventListener("DOMContentLoaded", function () {

  let x = document.getElementsByClassName("TOREMOVE_EVENTLISTENER");
  for (let i = 0; i < x.length; i++) {
    let elClone = x[i].cloneNode(true);
    x[i].parentNode.replaceChild(elClone, x[i]);
  }
  const stars = document.getElementById("addScrollDown");
  if (stars){
    stars.addEventListener("click", window.smoothScroll);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    const ratingReceived = document.getElementById("addScrollDown").getAttribute("data-done");
    const reviewsWidget = document.getElementById("shopify-section-product-reviews");
    if (!ratingReceived) {
      if (reviewsWidget) {
        reviewsWidget.classList.add("hidden");
      }
    }
  }, 2000);
});

window.smoothScroll = function () {
  var target = document.querySelector("#shopify-section-product-reviews");
  var scrollContainer = target;
  do {
    //find scroll container
    scrollContainer = scrollContainer.parentNode;
    if (!scrollContainer) return;
    scrollContainer.scrollTop += 1;
  } while (scrollContainer.scrollTop == 0);

  var targetY = 0;
  do {
    //find the top of target relatively to the container
    if (target == scrollContainer) break;
    targetY += target.offsetTop;
  } while ((target = target.offsetParent));

  scroll = function (c, a, b, i) {
    i++;
    if (i > 30) return;
    c.scrollTop = a + ((b - a) / 30) * i;
    setTimeout(function () {
      scroll(c, a, b, i);
    }, 20);
  };
  // start scrolling
  headerHeight = document.querySelector(".Header__Wrapper").clientHeight;
  scroll(scrollContainer, scrollContainer.scrollTop, targetY -   headerHeight, 0);
};

window.saveRating = function () {

  document.addEventListener("DOMContentLoaded", function() {
    var targetDiv = document.querySelector(".ProductItem__DetailWrapper");
    targetDiv.insertAdjacentHTML("afterend", divRating);
  });
};